import React from "react";
import { Mutation } from "react-apollo";
import { CLOSE_STEAKING } from "../../../queries";
import { stakingLang } from "./stakingLang";

function getAge(dateString) {
    var today = new Date();
    var birthDate = new Date(dateString);
    var age = today.getFullYear() - birthDate.getFullYear();
    var m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
        age--;
    }
    return age;
}

class ModalSteak extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            deposit: 0,
            Language : localStorage.getItem('language') ? localStorage.getItem('language') : 'en',
        };
    }

    closeSteakingEvent = (event, closeSteaking) => {
        event.preventDefault();        
        closeSteaking().then(({ data }) => {
            console.log(data.closeSteaking);
            // this.props.refetch();
            window.open(`https://launch.artyfact.game/staking/`, '_top');
        })
    }; 
    
    render() {
        let self = this;
        // const DateEnd = new Date(+this.props.Steak.DateEnd);
        const DateStart = new Date(+this.props.Steak.DateStart);
        const CurrentDate = new Date();
        return (
            <>
                <div className="text-center" style={{color: "#ffffff"}}>
                    {stakingLang.modal1[this.state.Language]}<br/>
                    {stakingLang.modal2[this.state.Language]} {getAge(DateStart) > 1 ? "0" : "15"} %
                </div>
                {!this.props.Steak.close ? (
                    <Mutation mutation={CLOSE_STEAKING} variables={{ 
                        steakid: this.props.Steak._id,
                    }} >
                        {(closeSteaking, { data, loading, error }) => {
                            return (
                                <div className="package-but buy-botton" style={{'margin-top' : '20px'}} onClick={event => self.closeSteakingEvent(event, closeSteaking)}>
                                    {stakingLang.modal_close[this.state.Language]}
                                </div>
                            )
                        }}
                    </Mutation>
                ) : (
                    <div className="package-but-disable buy-botton" style={{'margin-top' : '20px'}}>
                        {stakingLang.modal_ttl[this.state.Language]}
                    </div>
                )}
            </>    
        )
    }
}

export default ModalSteak